import PropTypes from 'prop-types';
import './styles/globalPrimaryStyles.css';

const GlobalPrimary = ({ ariaLabel, children, className, contextDropdown }) => (
  <nav
    aria-label={ariaLabel}
    className={`global-primary-navigation bg-gray-6 h-full text-center z-navigation ${className}`}
  >
    {contextDropdown ? (
      <div className="global-primary-navigation-container pb-4">
        {contextDropdown}
      </div>
    ) : null}
    <div className="global-primary-navigation-container flex flex-col flex-nowrap items-center justify-start text-center">
      {children}
    </div>
  </nav>
);

GlobalPrimary.defaultProps = {
  className: '',
};

GlobalPrimary.propTypes = {
  /**
   * ARIA label for the overall navigation
   */
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  /**
   * Any custom CSS classes to add to the navigation
   */
  className: PropTypes.string,
  /**
   * Contextual dropdown element to be inserted at the top of the navigation
   */
  contextDropdown: PropTypes.node.isRequired,
};

export default GlobalPrimary;
